"use client";

import React from "react";
import { Link } from "@/components/common/Link";
import { Button } from "@/components/ui/button";
import { useRevealOnScroll } from "@/hooks/useRevealOnScroll";
export default function EnvisionYourSpace() {
  const {
    ref: contentRef,
    isVisible: isContentVisible
  } = useRevealOnScroll({
    threshold: 0.2
  });
  return <section data-section-id="135623" id="the-natalia-signature" className="dark bg-background text-foreground relative overflow-hidden py-24 md:py-32 lg:py-40">
      {}
      <div className="absolute inset-0 bg-[url(https://wpvc-images.s3.us-east-1.amazonaws.com/images/1603357/img/architectural_blueprint_texture.png)] bg-cover bg-center opacity-5 pointer-events-none" aria-hidden="true" />

      <div className="container mx-auto px-4 relative z-10">
        <div ref={contentRef} className={`max-w-4xl mx-auto text-center transition-all duration-1000 ease-out ${isContentVisible ? "opacity-100 translate-y-0" : "opacity-0 translate-y-12"}`}>
          <h2 className="text-4xl md:text-5xl lg:text-6xl xl:text-7xl font-serif tracking-tight mb-10 text-foreground">
            Experience the Signature Glow
          </h2>
          
          <Button asChild size="lg" className="bg-[#f7ebeb] text-[#332f2e] hover:bg-[#f7ebeb]/90 text-base md:text-lg px-10 py-7 rounded-lg tracking-widest uppercase font-medium transition-all hover:scale-105 hover:shadow-[0_0_25px_rgba(247,235,235,0.3)] duration-500">
            <Link to="tel:07766733976">
              Book Appointment
            </Link>
          </Button>
        </div>
      </div>
    </section>;
}